module.exports = __webpack_public_path__ + "img/1-home.435a57e3.png";